// extracted by mini-css-extract-plugin
export default {"flexColumn":"AgencyInfoTab_flexColumn__M23c4","agencyInfoTab":"AgencyInfoTab_agencyInfoTab__jyXcI"};